/**
 * @desc 导出订单
 */
const URL = "/rantion-oms";
import http, { updateResponse } from "@/http";
export function request(params: API.oms.systemOrder.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
